const startButton = document.getElementById("start-btn");
const nextButton = document.getElementById("next-btn");
const showMeButton = document.getElementById("show-me-how-btn");
const questionContainerElement = document.getElementById("question18-container");
const questionElement = document.getElementById("question18");
const answerButtonsElement = document.getElementById("answer-buttons18");
const ctaElement = document.getElementById("cta18");


const questions18 = [
  {
    question:
      "What does your business use to remind employees of upcoming calls?",
    answers: [
      { text: "Online Calendar", correct: true },
      { text: "Wall or flip desk Calendar", correct: true },
      { text: "None of the above", correct: true },
    ],
  },
  {
    question: "How many call appointments do your teams miss a month?",
    answers: [
      { text: "1-2", correct: true },
      { text: "2-5", correct: true },
      { text: "Not sure", correct: true },
    ],
  },
  {
    question: "What do you want to improve?",
    answers: [
      { text: "Team Performance", correct: true },
      { text: "Company Profit", correct: true },
      { text: "Customer and Prospect Relationships", correct: true },
    ],
  },
];


let shuffledQuestions18, currentQuestionIndex18;

startButton.addEventListener("click", startQuiz);
nextButton.addEventListener("click", () => {
  currentQuestionIndex18++;
  setNextQuestion();
  rotateGallery();
});

function startQuiz() {
  startButton.classList.add("hide");
  shuffledQuestions18 = questions18.sort();
  // () => Math.random() - 0.5;
  currentQuestionIndex18 = 0;
  questionContainerElement.classList.remove("hide");
  setNextQuestion();
}

function setNextQuestion() {
  resetState();
  if(currentQuestionIndex18 > questions18.length - 1){
    displaySuccess();
    return
  } 
  showQuestion(shuffledQuestions18[currentQuestionIndex18]);
}

function displaySuccess(){
  ctaElement.innerText =
  "Good news! DYL’s Call Scheduling ensures your teams follow up as expected, making a great impression for long lasting business relationships. Click below to find out how.";
  questionContainerElement.classList.add("hide");
  ctaElement.classList.remove("hide");
  showMeButton.classList.remove("hide");
}

function showQuestion(question) {
  questionElement.innerText = question.question;
  question.answers.forEach((answer) => {
    const button = document.createElement("h5");
    button.innerText = answer.text;
    button.classList.add("btn-block");
    button.classList.add("btn-primary");
    button.classList.add("p-2");
    button.classList.add("transition-3d-hover");
    button.classList.add("text-center");
    if (answer.correct) {
      button.dataset.correct = answer.correct;
    }
    button.addEventListener("click", selectAnswer);
    answerButtonsElement.appendChild(button);
  });
}

function resetState() {
  clearStatusClass(document.body);
  nextButton.classList.add("hide");
  while (answerButtonsElement.firstChild) {
    answerButtonsElement.removeChild(answerButtonsElement.firstChild);
  }
}

function selectAnswer(e) {
  const selectedButton = e.target;
  const correct = selectedButton.dataset.correct;
  setStatusClass(document.body, correct);
  Array.from(answerButtonsElement.children).forEach((button) => {
    setStatusClass(button, button.dataset.correct);
    selectedButton.style.backgroundColor = "green";
  });
    nextButton.classList.remove("hide");
}


function setStatusClass(element, correct) {
  clearStatusClass(element);
  if (correct) {
    element.classList.add("correct");
  } else {
    element.classList.add("wrong");
  }
}

function clearStatusClass(element) {
  element.classList.remove("correct");
  element.classList.remove("wrong");
}

let counter = 0,
  gallery = [
    "https://images.dyl.com/marketing-web/images/quiz/woman-late-for-train-upset.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/man-rock-climbing-on-bottom-level.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/woman-smiling-excited-with-yellow-background.jpg",
  ];
function rotateGallery() {
  document.getElementById("ImgGalleryCS").src = gallery[counter];
  counter++;
  if (counter >= gallery.length) {
    counter = 0;
  }
}

